import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import { useTitle } from "../hooks/useTitle";
import { useProductos } from "../hooks/useProductos";
import CarritoCompras from "../components/CarritoCompras";
import { useForm } from "../hooks/useForm";
import { useAuth } from "../hooks/useAuth";
import { routes } from "../helpers/Routes";
import { enqueueSnackbar } from "notistack";
import PaymentForm from "../components/PaymentForm";
import styled from 'styled-components'
import { Button, Typography, Box } from "@mui/material";
import { RemoveRounded, AddRounded, ShoppingCart } from "@mui/icons-material";
import BuyButton from "../components/BuyButton";
import namer from 'color-namer';

// Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
  margin-top: 100px;
  background-color: #000000;
`

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
`

const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: #111827;
  margin-bottom: 2rem;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
`

const Card = styled.div`
  background-color: #222;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
`

const CardTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 1rem;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  margin-bottom: 0.5rem;
`

const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
  }
`

const ScrollArea = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding-right: 1rem;
`

const OrderItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

const ItemDetails = styled.div`
  flex: 1;
`

const ItemName = styled.h3`
  font-weight: 600;
  margin: 0;
`

const ItemInfo = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.25rem 0 0;
`

const ItemPrice = styled.p`
  font-weight: 500;
`

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
`

// Mock data for the cart items
const cartItems = [
  { id: 1, name: "Mountain Bike Pro", size: "M", price: 1299.99, quantity: 1 },
  { id: 2, name: "Road Bike Elite", size: "L", price: 1599.99, quantity: 1 },
  { id: 3, name: "City Cruiser", size: "S", price: 599.99, quantity: 2 },
]
function Checkout() {
  const navigate = useNavigate();

  const [openCart, setOpenCart] = useState(false);
  const { usuario } = useAuth();
  const { cart, postOrdenes, formatoCOP, getCart } = useProductos()
  const [city, setCity] = useState("");
  const [shipping, setShipping] = useState(0);
  const totalPagar = cart.reduce((sum, item) => sum + item?.precio * item?.cantidad, 0)
  console.log(cart)
  const { form, onChange } = useForm({ fullName: "", nombreEmpresa: "", pais: "Colombia", departamento: "", ciudad: "", calle: "", codigoZIP: "", email: "", telephone: "", total: totalPagar, cedula: '' });
  const { fullName, nombreEmpresa, pais, departamento, ciudad, calle, codigoZIP, email, telephone, total } = form;
  const sizeProducto = cart?.map((item) =>
    `${item.nombre} ${item.size} ${item.color} ${item.cantidad}`
  ).join(", ");

  useEffect(() => {
    if (usuario) {
      getCart(usuario?.id_usuario);
    }
  }, [])


  
  useEffect(() => {
    if (ciudad.trim() !== "") {
      fetch('https://api-v2.dev.mpr.mipaquete.com/getLocations', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'session-tracker': 'a0c96ea6-b22d-4fb7-a278-850678d5429c',
          'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2Nzk4ZWVkOTJiNDc2MzNlZWI4N2U4NjQiLCJuYW1lIjoiSm9yZ2UiLCJzdXJuYW1lIjoiR3VhcmRvIiwiZW1haWwiOiJkZWxpYXJvc2FybzExMkBnbWFpbC5jb20iLCJjZWxsUGhvbmUiOiIzMDA3NzgyODc3IiwiY3JlYXRlZEF0IjoiMjAyNS0wMS0yOFQxNDo1MTowNS4yMzdaIiwiZGF0ZSI6IjIwMjUtMDEtMjggMTY6NDY6MDQiLCJpYXQiOjE3MzgxMDA3NjR9.1amzeJHs6DFApl5-CPqDRCibVHQ37NQGOizDstz1WkA'
        }
      }).then((response) => response.json()).then((data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i]?.locationName.toUpperCase().includes(ciudad.toUpperCase())) {
            setCity(data[i]?.locationCode);
          }
        }
      }).catch((error) => {
        console.error('Error al obtener las ciudades:', error);
      })
    }
  }, [ciudad])

  let peso = cart?.map((item, idx) => {
    return item.cantidad * Number(item.peso.replace(" kg", ""))
  });

  useEffect(() => {
    if (city !== "") {
      fetch(`https://api-v2.dev.mpr.mipaquete.com/quoteShipping`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'session-tracker': 'a0c96ea6-b22d-4fb7-a278-850678d5429c',
          'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2Nzk4ZWVkOTJiNDc2MzNlZWI4N2U4NjQiLCJuYW1lIjoiSm9yZ2UiLCJzdXJuYW1lIjoiR3VhcmRvIiwiZW1haWwiOiJkZWxpYXJvc2FybzExMkBnbWFpbC5jb20iLCJjZWxsUGhvbmUiOiIzMDA3NzgyODc3IiwiY3JlYXRlZEF0IjoiMjAyNS0wMS0yOFQxNDo1MTowNS4yMzdaIiwiZGF0ZSI6IjIwMjUtMDItMDYgMTE6MzU6MDIiLCJpYXQiOjE3Mzg4NTk3MDJ9.iEEyO9OX2bwHw2wzwbjfeyjJc3sjNYmOkMZmDCHO_H4'
        },
        body: JSON.stringify({
          "originCountryCode": "170",
          "originLocationCode": "11001000",
          "destinyCountryCode": "170",
          "destinyLocationCode": city,
          "quantity": 1,
          "width": 20,
          "length": 150,
          "height": 100,
          "weight": peso[0],
          "declaredValue": 10000
        }),
      }).then((response) => response.json()).then((data) => {
        const cheapestShipping = Math.min(...data.map(item => item.shippingCost));

        setShipping(cheapestShipping);
      })
    }
  }, [city])
  const handleSubmit = (e) => {
    e.preventDefault()
    if (Object.values(form).some(value => value.trim() === "")) {
      alert("All fields are required")
      return
    }
    // Here you would typically send the order to your backend
    console.log("Order submitted:", form)
    // router.push("/confirmation")
  }

  const handlerPayment = (e) => {
    e.preventDefault();

    if (fullName?.trim() === "" || nombreEmpresa?.trim() === "" || pais?.trim() === "" ||
      departamento?.trim() === "" || ciudad?.trim() === "" || calle?.trim() === "" || codigoZIP?.trim() === ""
      || email?.trim() === "" || telephone?.trim() === "" || totalPagar === 0) {
      enqueueSnackbar("Todos los campos son obligatorios", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        }
      });
      return;

    }

    postOrdenes({ fullName, nombreEmpresa, pais, departamento, ciudad, calle, codigoZIP, email, telephone, total: Number(shipping) + totalPagar, productos: sizeProducto, cedula: form.cedula }).then((data) => {

      if (data.status === 200) {
        navigate(routes.confirmation + `/${data.orden.norden}`);
      }

    }).catch((err) => {
      if (err === 1) {
        enqueueSnackbar("Hubo un error, vuelva mas tarde o intentelo nuevamente", {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
          }
        });
      }
    });
  }


  function NameColor(item){
    try {
      const color = namer(item?.color)?.basic[0]?.name
      return color
    } catch (error) {
      return item?.color
    }
  }

  return (
    <div>
      <Header setOpenCart={setOpenCart} openCart={openCart} />
      <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
      <PageContainer>

        <ContentWrapper >
          <Grid>
            <Card>
              <CardTitle>Detalles de la Orden</CardTitle>
              <Form onSubmit={handleSubmit}>
                <FormRow>
                  <FormGroup>
                    <Label htmlFor="fullName">Nombre Completo</Label>
                    <Input id="fullName" name="fullName" value={fullName} onChange={(event) => onChange(event, "fullName")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="companyName">Nombre de Compañía (opcional)</Label>
                    <Input id="companyName" name="companyName" value={nombreEmpresa} onChange={(event) => onChange(event, "nombreEmpresa")} />
                  </FormGroup>
                </FormRow>
                <FormGroup>
                  <Label htmlFor="country">País</Label>
                  <Input id="country" name="country" value={pais} onChange={(event) => onChange(event, "pais")} required readOnly />
                </FormGroup>
                <FormRow>
                  <FormGroup>
                    <Label htmlFor="state">Estado</Label>
                    <Input id="state" name="state" value={departamento} onChange={(event) => onChange(event, "departamento")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="ciudad">Ciudad</Label>
                    <Input id="ciudad" name="ciudad" value={ciudad} onChange={(event) => onChange(event, "ciudad")} required />
                  </FormGroup>
                </FormRow>
                <FormGroup>
                  <Label htmlFor="street">Calle</Label>
                  <Input id="street" name="street" value={calle} onChange={(event) => onChange(event, "calle")} required />
                </FormGroup>
                <FormRow>
                  <FormGroup>
                    <Label htmlFor="zipCode">Codigo Postal (ZIP Code, opcional)</Label>
                    <Input id="zipCode" name="zipCode" value={codigoZIP} onChange={(event) => onChange(event, "codigoZIP")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="phone">Phone</Label>
                    <Input id="phone" name="phone" value={telephone} onChange={(event) => onChange(event, "telephone")} required />
                  </FormGroup>
                </FormRow>
                <FormGroup>
                  <Label htmlFor="email">Cedula</Label>
                  <Input id="cedula" name="cedula" type="text" value={form.cedula} onChange={(event) => onChange(event, "cedula")} required />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" name="email" type="email" value={email} onChange={(event) => onChange(event, "email")} required />
                </FormGroup>
                <BuyButton onClick={handlerPayment}>
                  Comprar Ahora
                </BuyButton>
              </Form>
            </Card>
            <div style={{ marginBottom: "40px" }}>

              <Card>
                <CardTitle>Pedido</CardTitle>
                <ScrollArea>
                  {cart?.map((item) => (
                    <OrderItem key={item?.id}>
                      <ItemDetails>
                        <ItemName>{item?.nombre}</ItemName>
                        <ItemInfo>Size: {item?.size}</ItemInfo>
                        <ItemInfo>Quantity: {item?.cantidad}</ItemInfo>
                        <ItemInfo>Color: {item ? NameColor(item) : ""}</ItemInfo>
                      </ItemDetails>
                      <ItemPrice style={{ color: "green" }}>{formatoCOP.format(item?.precio * item?.cantidad)}</ItemPrice>
                    </OrderItem>
                  ))}
                  <OrderItem>
                    <ItemDetails>
                      Envio:
                    </ItemDetails>
                    <ItemPrice style={{ color: "green" }}>
                      {formatoCOP.format(shipping)}
                    </ItemPrice>
                  </OrderItem>
                </ScrollArea>
                <TotalRow>
                  <span>Total</span>
                  <span style={{ color: "green" }}>{formatoCOP.format(Number(shipping) + totalPagar)}</span>
                </TotalRow>
              </Card>
            </div>
          </Grid>
        </ContentWrapper>
        <Footer />
      </PageContainer>

    </div>
  )
}

export default Checkout

